// React
import React from 'react';
import { Card, Col, Row } from 'reactstrap';

// Containers Injections
import {
  PageWrapper,
  FloatButton,
  DropdownDatatable,
} from '../../containers/componentsInjection';

export const SuppliersPage = ({
  history,
  columns,
  handleEdit,
  handleDelete,
  suppliesList,
  setActiveStatus,
  tog_animationLeft,
}) => {
  return (
    <PageWrapper title={'Fornecedores'}>
      <Row>
        <Col xs={12}>
          <Card>
            <DropdownDatatable
              keysSearch={['name', 'cnpj_cpf']}
              title="Fornecedores"
              pagination
              perPage={10}
              persistTableHead
              isSearchRemote={false}
              handleButton={tog_animationLeft}
              actions={[
                {
                  id: 1,
                  name: 'edit',
                  label: 'Editar',
                  onPress: (cellProps) => handleEdit(cellProps),
                  icon: 'la-pen',
                  classNameColorIcon: 'primary',
                },
              ]}
              handleDelete={(cellProps) => handleDelete(cellProps)}
              hasStatusSelect
              data={suppliesList ? suppliesList : []}
              columns={columns}
              handleStatusSelect={(e) => setActiveStatus(e.target.value)}
            />
          </Card>
        </Col>
      </Row>
      <FloatButton handleButton={() => history.push('/fornecedores/novo')} />
    </PageWrapper>
  );
};
